import { defineComponent, inject, PropType } from 'vue';
import { report } from '_c/business/api/report';
import { UserManager } from '_c/business/manager/user';
import { IMsg } from '_c/typings/model/im';

export default defineComponent({
  name: 'UrlTextNode',
  props: {
    text: {
      type: String as PropType<string>,
      default: '',
    },
    innerText: {
      type: String as PropType<string>,
      default: '',
    },
    displayText: {
      type: String as PropType<string>,
      default: '',
    },
  },
  setup(): {
    messageData: IMsg
  } {
    return {
      messageData: inject('messageData') as IMsg,
    };
  },
  computed: {
  },
  methods: {
    onClickUrlHandler(): void {
      const uid = UserManager.getInstance().getCurrentUid();
      const userType = UserManager.getInstance().getUser(uid)?.userType?.toString() ?? '0';
      report({
        reportParamsList: [{
          operId: '1916000110201',
          groupId: this.$store.state.group.selectGroupId,
          channelId: this.$store.state.group.selectChannelId || '0',
          messageType: this.messageData.l2Type,
          toUid: this.messageData.senderUid,
          ext1: userType,
          messageId: this.messageData.origin?.ID,
        }],
      });
      window.open(this.text);
    },
  },
});
